import React from "react";

import { Grid } from "@material-ui/core";
import TextField from '@mui/material/TextField';

export default function Filters({
  onChange
}) {

  const firstTime = React.useRef(false);
  const [date, setDate] = React.useState(null);
  const [category, setCategory] = React.useState(null);
  const [operation, setOperation] = React.useState(null);

  React.useEffect(() => {
    let delayDebounceFn = null;
    if (firstTime.current) {
      delayDebounceFn = setTimeout(() => {
        onChange({category: category, operation: operation, date: date});
      }, 250)
    } else {
      firstTime.current = true
    }
    return () => {
      clearTimeout(delayDebounceFn)
    }
  }, [date, category, operation])

  const changeCategory = (event) => {
    let value = event.target.value.trim();
    if (value)
      setCategory(value);
    else
      setCategory(null);
  } 

  const changeOperation = (event) => {
    let value = event.target.value.trim();
    if (value)
      setOperation(value);
    else
      setOperation(null);
  } 

  const changeDate = (event) => {
    let value = event.target.value;
    if (!value){
      setDate(null);
    } else {
      let aux = new Date(value);
      setDate(aux.getTime() + (aux.getTimezoneOffset() * 60000));
    }
  } 

  return (
      <Grid container spacing={2}>
           <Grid item xs={true}>
              <TextField 
                label="Categoría" 
                size="small" 
                fullWidth 
                variant="outlined" 
                onChange={changeCategory}/>
            </Grid>
            <Grid item xs={true}>
              <TextField 
                label="Operación" 
                size="small" 
                fullWidth 
                variant="outlined" 
                onChange={changeOperation}/>
            </Grid>
            <Grid item xs={true}>
              <TextField
                id="date"
                label="Fecha"
                fullWidth 
                size="small" 
                type="date"
                name="date"
                onChange={changeDate}
                InputLabelProps={{
                  shrink: true
                }}/>
            </Grid>
      </Grid>
  );
}
